import React from 'react';

function LogoNegativo(props) {
  return (
    <img
      alt="Logo"
      height="60px"
      src="/static/logo-grey.svg"
      width="100px"
      {...props}
    />
  );
}

export default LogoNegativo;
